// Google reCAPTCHA (v3 clásico o Enterprise) para el formulario público (ERB
// server-rendered). Lee la config embebida (#form-recaptcha-config, incluye el
// flag `enterprise`) y expone window.portalRecaptcha para que el handler de envío
// obtenga un token justo antes de enviar (los tokens caducan ~2 min, por eso se
// generan al momento del submit). El servidor revalida siempre (autoritativo).

const CONFIG_NODE_ID = 'form-recaptcha-config';
const DEFAULT_ACTION = 'form_submit';

export const readRecaptchaConfig = () => {
  const node = document.getElementById(CONFIG_NODE_ID);
  if (!node) return null;
  try {
    const parsed = JSON.parse(node.textContent || '{}');
    if (!parsed || !parsed.enabled || !parsed.siteKey) return null;
    return {
      siteKey: parsed.siteKey,
      action: parsed.action || DEFAULT_ACTION,
      enterprise: Boolean(parsed.enterprise),
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[reCAPTCHA] error parsing config:', error);
    return null;
  }
};

// Enterprise expone su API bajo window.grecaptcha.enterprise; el clásico bajo
// window.grecaptcha directamente. Se resuelve al momento del submit (ya cargado).
export const resolveGrecaptcha = enterprise => {
  const root = window.grecaptcha;
  if (!root) return undefined;
  return enterprise ? root.enterprise : root;
};

// Resuelve con un token v3 nuevo, o rechaza si grecaptcha no está disponible o falla.
export const executeRecaptcha = (grecaptcha, siteKey, action) =>
  new Promise((resolve, reject) => {
    if (!grecaptcha || typeof grecaptcha.execute !== 'function') {
      reject(new Error('reCAPTCHA no está disponible'));
      return;
    }
    const run = () =>
      grecaptcha.execute(siteKey, { action }).then(resolve).catch(reject);
    if (typeof grecaptcha.ready === 'function') {
      grecaptcha.ready(run);
    } else {
      run();
    }
  });

export const initFormRecaptcha = () => {
  const config = readRecaptchaConfig();
  if (!config) {
    delete window.portalRecaptcha;
    return;
  }
  window.portalRecaptcha = {
    isEnabled: () => true,
    execute: () =>
      executeRecaptcha(
        resolveGrecaptcha(config.enterprise),
        config.siteKey,
        config.action
      ),
  };
};
